<template>
  <v-app id="inspire">
    <loading />
    <confirm ref="confirm"></confirm>

    <v-navigation-drawer
      v-model="navigation.shown"
      v-if="$route.path !== '/home/dashboard'"
    >
      <navBar :navigation = "navigation" />
    </v-navigation-drawer>

    <v-app-bar style="height: 54px;">
      <v-container fluid :style="{ height: $route.path === '/home/dashboard' ? '90px' : $route.path === '/module/documents' ? '70px' : '75px' }">
        <v-row>
          <v-col v-if="$route.path !== '/module/documents'" :md="$route.path !== '/home/dashboard' ? '1' : '2'" cols="1">
            <v-app-bar-nav-icon
              @click="navigation.shown = !navigation.shown"
              v-if="$route.path !== '/home/dashboard' && $route.path !== '/module/documents'"
            ></v-app-bar-nav-icon>
            <div class="text-center" v-else>
                <img :src="getCurrentCompany?.logo ? getFileServerUrl + getCurrentCompany?.logo : '@/assets/image/logo.png'" class="logo2" style="width: 220px; height: 40px;"/>
            </div>
          </v-col>

          <v-col
            md="1"
            cols=""
            class="align-self-center d-none d-md-block pa-0 text-center"
            v-if="$route.path === '/module/documents'"
          >
            <v-icon
              title="Step Backward"
              color="blue-grey-lighten-1"
              @click="$router.go(-1)"
              icon="mdi mdi-step-backward"
            ></v-icon>
          </v-col>

          <v-col
            :md="$route.path !== '/home/dashboard' && $route.path === '/module/documents' ? '3' : '2'"
            cols="6"
            class="align-self-center d-none d-md-block pa-0"
          >
            <v-app-bar-title><breadCrumbs></breadCrumbs></v-app-bar-title>
          </v-col>

          <v-col v-if="$route.path !== '/home/dashboard'" md="1" cols="1"></v-col>

          <v-col
            md="1"
            cols=""
            class="align-self-center d-none d-md-block pa-0 text-center"
            v-if="$route.path !== '/module/documents'"
          >
            <v-icon
              title="Step Backward"
              color="blue-grey-lighten-1"
              @click="$router.go(-1)"
              icon="mdi mdi-step-backward"
            ></v-icon>
          </v-col>
          

          <v-col md="7" cols="10" class="pa-0 align-self-center">
            <v-row>
              <v-col cols="4" class="align-self-center">
                <v-autocomplete
                  label="Company"
                  variant="outlined"
                  density="compact"
                  single-line
                  hide-details="auto"
                  bg-color="grey-lighten-4"
                  v-model="selectedCompany"
                  :items="getCompanyList.filter((item) => item.status == 1)"
                  :item-title="(item) => `${item.name} - ${item.code}`"
                  item-value="id"
                  :disabled="getCompanyList.length == 1"
                  :loading="company_loading"
                  autocomplete="off"
                ></v-autocomplete>
              </v-col>

              <v-col cols="3" class="align-self-center px-0">
                <v-autocomplete
                  label="Branch"
                  variant="outlined"
                  density="compact"
                  single-line
                  hide-details="auto"
                  bg-color="grey-lighten-4"
                  v-model="selectedBranch"
                  :items="
                    getBranchList.filter(
                      (item) => item.company_id == this.selectedCompany
                    )
                  "
                  :item-title="(item) => `${item.name} - ${item.code}`"
                  item-value="id"
                  :loading="branch_loading"
                  :disabled="getBranchList.length == 1"
                  autocomplete="off"
                  @update:modelValue="
                    (value) => {
                      this.tempId = value;
                      this.switchBranch(this.tempId);
                    }
                  "
                ></v-autocomplete>
              </v-col>

             <v-col cols="1" class="text-center align-self-center">
  <div class="text-center">
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      location="end"
    >
      <!-- 🔔 ACTIVATOR -->
      <template v-slot:activator="{ props }">
        <div
          v-bind="props"
          class="pa-2"
          style="
            border-radius: 50%;
            height: 40px;
            width: 40px;
            background-color: #f5f5f5;
            display: flex;
            align-items: center;
            justify-content: center;
          "
        >
          <v-badge
            :content="unreadCount"
            color="red"
            v-if="unreadCount > 0"
          >
            <v-icon icon="mdi mdi-bell" size="small" />
          </v-badge>

          <v-icon v-else icon="mdi mdi-bell" size="small" />
        </div>
      </template>

      <!-- 📋 MENU CONTENT -->
      <v-card min-width="300">
        <v-list>
          <v-list-item title="Notifications" />
        </v-list>

        <v-divider />

        <v-list>
         <v-list-item
  v-for="n in notifications"
  :key="n.id"
  @click="openNotification(n)"
  :class="{ 'bg-blue-lighten-5': !n.read }"
>
  <!-- AVATAR -->
  <template #prepend>
    <v-avatar size="36">
      <img
        v-if="(n.data?.sender || n.sender)?.avatar"
        :src="getFileServerUrl + (n.data?.sender || n.sender).avatar"
      />
      <v-icon v-else icon="mdi mdi-account-circle" />
    </v-avatar>
  </template>

  <!-- SENDER ROW -->
  <div class="d-flex align-center mb-1">
    <strong class="text-body-2">
      {{ (n.data?.sender || n.sender)?.name || 'System' }}
    </strong>

    <v-chip
      v-if="!n.read"
      size="x-small"
      color="primary"
      class="ml-2"
    >
      New
    </v-chip>
  </div>

  <!-- TITLE -->
  <v-list-item-title class="text-body-2">
    {{ n.data?.title || n.title || 'Notification' }}
  </v-list-item-title>

  <!-- MESSAGE -->
<v-list-item-subtitle class="text-caption">
  {{
    (n.data?.message || n.message || '').length > 50
      ? (n.data?.message || n.message || '').slice(0, 50) + '...'
      : (n.data?.message || n.message || '')
  }}
</v-list-item-subtitle>

  <!-- TIME -->
  <v-list-item-subtitle class="text-caption text-grey mt-1">
    <v-icon icon="mdi mdi-clock-outline" size="x-small" class="mr-1"></v-icon>
    {{ formatNotificationTime(n.created_at) }}
  </v-list-item-subtitle>

  <!-- DIVIDER -->
  <v-divider class="mt-2" />
</v-list-item>


          <v-list-item v-if="!notifications.length">
            <v-list-item-title>
              No notifications
            </v-list-item-title>
          </v-list-item>
        </v-list>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn variant="text" @click="markAllAsRead">
            Mark as read
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</v-col>


              <v-col cols="3" class="align-self-center">
                <div class="text-subtitle-2 text-right">
                  {{ user.fullName }}
                </div>
                <div class="text-caption text-right">{{ user.role_name }}</div>
              </v-col>

              <v-col cols="1" class="text-left">
                <v-menu min-width="200px" rounded>
                  <template v-slot:activator="{ props }">
                    <v-btn icon v-bind="props">
                      <v-avatar
                        icon="$vuetify"
                        :image="getFileServerUrl + (user.imageThumb != null ? user.imageThumb : 'uploads/demo_images/user.png') "
                        size="40"
                      ></v-avatar>
                    </v-btn>
                  </template>

                  <v-card
                    class="mx-auto pa-4"
                    elevation="2"
                    max-width="auto"
                    rounded="lg"
                  >
                    <v-card-text>
                      <div class="mx-auto text-center">
                        <v-avatar
                          icon="$vuetify"
                          :image="
                            getFileServerUrl +
                            (user.imageThumb != null
                              ? user.imageThumb
                              : 'uploads/demo_images/user.png')
                          "
                          size="40"
                        ></v-avatar>
                        <h3>{{ user.fullName }}</h3>
                        <p class="text-caption mt-1">
                          {{ user.role_name }}
                        </p>
                        <v-divider class="my-1"></v-divider>
                        <v-btn
                          variant="text"
                          prepend-icon="mdi mdi-lock-reset"
                          class="icon-size-24"
                          @click="goTo('/administration/change-password')"
                        >
                          Change Password
                        </v-btn>
                        <v-divider class="my-1"></v-divider>
                        <v-btn
                          color="error"
                          variant="text"
                          prepend-icon="mdi mdi-logout"
                          @click="logout"
                        >
                          Log out
                        </v-btn>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-menu>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>

    <v-main>
      <router-view />

        <v-footer height="auto" style="background-color: rgb(232 232 232)">
        <v-spacer></v-spacer>

        <span class="text-caption">
          © {{ new Date().getFullYear() }}
          Developed By <a
            href="https://www.datascapeit.com/"
            target="_blank"
            rel="noopener noreferrer"
            class="text-decoration-none font-weight-medium"
          >
            Datascape IT Ltd.
          </a>
          All rights reserved.
        </span>
      </v-footer>
    </v-main>
  </v-app>
</template>

<script>
import navBar from "./navBar.vue";
import { ref } from "vue";
import loading from "@/components/utils/loading.vue";
import confirm from "@/components/utils/confirm.vue";
import { toast } from "vue3-toastify";
import breadCrumbs from "@/components/utils/breadCrumbs.vue";
import Pusher from 'pusher-js'
import Axios from "axios";
import { prefix, baseURL, getNotifications, markNotificationAsRead, markAllNotificationsAsRead, getPusherCredentials } from "@/store/api";

//  const drawer = ref(null)
export default {
  components: {
    navBar,
    loading,
    breadCrumbs,
    confirm,
  },
  data: () => ({
    notifications: [],
    unreadCount: 0,
    pusher: null,
    drawer: true,
    fav: true,
    menu: false,
    message: true,
    hints: true,
    selectedBranch: null,
    selectedCompany: null,
    branch_loading: true,
    company_loading: true,
    user: {
      firstName: "",
      fullName: "",
      lastName: "",
      mobile: "",
      image: "",
      imageThumb: "",
      email: "",
      branch_id: null,
      role_name: "",
    },
    navigation: {
      shown: false,
    },
    currentBranch: {
      id: null,
      name: "",
      code: "",
      company: {
        id: null,
        name: "",
        code: "",
      },
    },
  }),
  created() {
    this.$store.dispatch("getCompanyList").then((data) => {
      this.company_loading = false;
      this.selectedCompany = parseInt(this.currentBranch.company.id);
    });

    this.$store.dispatch("getBranchList").then((data) => {
      this.branch_loading = false;
      this.selectedBranch = parseInt(this.currentBranch.id);
    });
  },
  watch: {
    selectedCompany(val) {
      this.selectedBranch = null;
    },
    "$route.path"(val) {
      if(val==='/module/documents'){
        this.navigation.shown = false;
      }else{
        this.navigation.shown = true;
      }
    }
  },
  computed: {
    getMessage() {
      return this.$store.getters.getMessage;
    },
    getCurrentCompany() {
      return this.$store.getters.getCurrentCompany;
    },
    getSidebarCollapse() {
      return this.$store.getters.getSidebarCollapse;
    },
    getCompanyList() {
      return this.$store.getters.getCompanyList.filter(
        (item) => item.status == 1
      );
    },
    getBranchList() {
      return this.$store.getters.getBranchList.filter(
        (branch) => branch.status == 1
      );
    },
    getCurrentBranch() {
      return this.$store.getters.getCurrentBranch;
    },
    getAuthUser() {
      return this.$store.getters.getAuthUser;
    },
    getFileServerUrl() {
      return this.$store.getters.getFileServerUrl;
    },
  },
  methods: {
formatNotificationTime(dateTime) {
  if (!dateTime) return '';
  
  try {
    const now = new Date();
    const notificationDate = new Date(dateTime);
    const diffInSeconds = Math.floor((now - notificationDate) / 1000);
    
    // Less than a minute
    if (diffInSeconds < 60) {
      return 'Just now';
    }
    
    // Less than an hour
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    if (diffInMinutes < 60) {
      return `${diffInMinutes} ${diffInMinutes === 1 ? 'minute' : 'minutes'} ago`;
    }
    
    // Less than a day
    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) {
      return `${diffInHours} ${diffInHours === 1 ? 'hour' : 'hours'} ago`;
    }
    
    // Less than a week
    const diffInDays = Math.floor(diffInHours / 24);
    if (diffInDays < 7) {
      return `${diffInDays} ${diffInDays === 1 ? 'day' : 'days'} ago`;
    }
    
    // More than a week - show date and time
    const options = { 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    };
    return notificationDate.toLocaleDateString('en-US', options);
  } catch (error) {
    console.error('Error formatting notification time:', error);
    return '';
  }
},
async fetchNotifications() {
  try {
    const res = await Axios.get(getNotifications);
  
    if (res.data.success) {
      
      const notificationsData = res.data.notifications?.data || res.data.notifications || [];
      
      this.notifications = notificationsData.map(n => ({
        id: n.id,
        type: n.type,
        data: n.data || {},
        read: !!n.read_at,
        read_at: n.read_at,
        created_at: n.created_at,
      }));

      // Use unread_count from backend response
      this.unreadCount = res.data.unread_count || 0;
      
    } else {
      this.notifications = [];
      this.unreadCount = 0;
    }
  } catch (error) {
  
    toast.error("Failed to load notifications");
    this.notifications = [];
    this.unreadCount = 0;
  }
},

async openNotification(notification) {
  if (!notification.read) {
    try {
      await Axios.post(
        markNotificationAsRead,
        { notification_id: notification.id }
      );

      notification.read = true;
      notification.read_at = new Date().toISOString();
      this.unreadCount = Math.max(0, this.unreadCount - 1);
    } catch (error) {
      toast.error("Failed to mark notification as read");
    }
  }

  // Navigate to URL if provided in notification data
  if (notification.data?.url) {
    let url = notification.data.url;

    try {
      const urlObj = new URL(url);
      url = urlObj.pathname + urlObj.search;
    } catch (e) {
 
      if (!url.startsWith('/')) {
        url = `${window.location.origin}`+url;
      }
    }

    this.$router.push(url);
  }

  this.menu = false;
},

async markAllAsRead() {
  try {
    const res = await Axios.post(markAllNotificationsAsRead);

    if (res.data.success) {
      this.notifications.forEach(n => {
        n.read = true;
        n.read_at = new Date().toISOString();
      });
      this.unreadCount = 0;
      toast.success(res.data.message || "All notifications marked as read");
    }
  } catch (error) {
    toast.error("Failed to mark all notifications as read");
  }
},
    logout() {
      let self = this;
      this.$root
        .$confirm("Are you sure you want to log out?", {
          color: "red",
          item: "Logout",
        }).then((confirm) => {
          if (confirm) {
            self.$store
              .dispatch("logoutUser")
              .then(function (response) {
                self.$router.push("/");
              })
              .catch(function (error) {
              
                toast.error("Something Went Wrong!");
              });
          }
        });
    },
    getLoad() {
      this.$store.commit("SET_LOADING", { color: "indigo" });
    },
    goTo(val) {
      this.$router.push({ path: val }).catch((err) => {});
    },
    switchBranch(id) {
      const selectedBranchInfo = this.getBranchList.find(
        (item) => item.id == id
      );
      const title = selectedBranchInfo.title;
      let self = this;
      this.$root
        .$confirm("Are you sure that you want to switch?", {
          color: "info",
          item: title,
        })
        .then((confirm) => {
          if (confirm) {
            this.$store
              .dispatch("changeBranch", { branch_id: selectedBranchInfo.id })
              .then(function (response) {
                self.goTo("/home/dashboard");
                toast.success(response.data.message);
              })
              .catch(function (error) {
               
                toast.error(error.response.data.message);
              });
          } else {
            let users_info = self.getAuthUser;
            self.selectedCompany = parseInt(users_info.company_id);
            self.$nextTick(() => {
              self.selectedBranch = parseInt(users_info.branch_id);
            });
          }
        });
    },
  },
  async mounted() {

   

    this.$root.$confirm = this.$refs.confirm.open;
    let user_info = this.getAuthUser;

    this.user.imageThumb = user_info.image_thumb;
    this.user.fullName = user_info.full_name;
    this.user.email = user_info.email;
    this.user.role_name = user_info.role_name;

    this.currentBranch = this.getCurrentBranch;
    this.selectedBranch = this.currentBranch.id;
    this.selectedCompany = this.currentBranch.company.id;

    if (!this.getCompanyList.length) {
      this.selectedCompany = null;
    }
    if (!this.getBranchList.length) {
      this.selectedBranch = null;
    }
    // 1️⃣ Request browser notification permission
    if ('Notification' in window && Notification.permission === 'default') {
      Notification.requestPermission()
    }

    // 2️⃣ Load existing notifications
    this.fetchNotifications()

    // 3️⃣ Setup Pusher for real-time notifications
    const token = localStorage.getItem('token')
    const userId = this.getAuthUser?.id

    if (token && userId) {
      try {
        // Fetch Pusher credentials from backend
        const credentialsRes = await Axios.get(getPusherCredentials);
        const credentials = credentialsRes.data?.data;

        if (!credentials?.pusher_enabled || !credentials?.pusher_app_key) {
          console.warn("Pusher is disabled or credentials not available");
          return;
        }

      
        const pusher = new Pusher(credentials.pusher_app_key, {
          cluster: credentials.pusher_app_cluster || 'ap2',
          authEndpoint: `${baseURL}/api/broadcasting/auth`,
          auth: {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        })

        const channelName = `private-App.Models.User.${userId}`
        const channel = pusher.subscribe(channelName)

        // Log subscription events
        channel.bind('pusher:subscription_succeeded', () => {
        })

        channel.bind('pusher:subscription_error', (error) => {
          console.error("Pusher subscription error:", error);
        })

        channel.bind(
          'Illuminate\\Notifications\\Events\\BroadcastNotificationCreated',
          (data) => {
            // Normalize notification data structure
            const notification = {
              id: data.id || data.notification?.id,
              data: data.data || data.notification?.data || data,
              read: false,
              read_at: null,
              created_at: data.created_at || new Date().toISOString(),
            }

            // Prevent duplicates
            if (!this.notifications.some(n => n.id === notification.id)) {
              this.notifications.unshift(notification)
              this.unreadCount++
           
              // Show toast notification if page is visible
              if (document.visibilityState === 'visible' && notification.data?.title) {
                toast.info(notification.data.message || notification.data.title, {
                  title: notification.data.title || 'New Notification'
                })
              }

              // Browser notification if page is not visible
           const limitText = (text, limit = 50) => {
                if (!text) return ''
                return text.length > limit
                  ? text.substring(0, limit) + '...'
                  : text
              }

              if (Notification.permission === 'granted' && document.visibilityState !== 'visible') {
                new Notification(
                  limitText(notification.data?.title || 'New Notification', 50),
                  {
                    body: limitText(notification.data?.message || '', 50),
                    icon: '/favicon.ico'
                  }
                )
              }
            } else {
            }
          }
        )

        // Store pusher instance for cleanup if needed
        this.pusher = pusher
      } catch (error) {
        console.error("Error setting up Pusher:", error)
      }
    } else {
      console.warn("Cannot setup Pusher: missing token or userId", { token: !!token, userId });
    }

  },
  
};
</script>

<style>
  .v-toolbar-title__placeholder {
    overflow: unset !important;
  }
  .v-application__wrap {

    min-height: 82.9vh !important
    
}
</style>
